/**
 * 获取 url 中的参数传值
 *
 * @param {string} name
 * @returns {(string | null)}
 */
export function getQueryParameter(name: string): string | null {
  const query = window.location.search.substring(1);
  const vars = query.split('&');
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split('=');
    if (decodeURIComponent(pair[0]) === name) {
      return decodeURIComponent(pair[1]);
    }
  }
  return null
}


/**
 * 删除 url 中的某个参数
 *
 * @param {*} url
 * @param {*} parameter
 * @returns
 */
export function removeURLParameter(parameter: string, url: string = window.location.href) {
  var urlparts = url.split('?');   
  if (urlparts.length >= 2) {

      var prefix = encodeURIComponent(parameter) + '=';
      var pars = urlparts[1].split(/[&;]/g);

      for (var i = pars.length; i-- > 0;) {    
          if (pars[i].lastIndexOf(prefix, 0) !== -1) {  
              pars.splice(i, 1);
          }
      }

      return urlparts[0] + (pars.length > 0 ? '?' + pars.join('&') : '');
  }
  return url;
}

export function isIOS() {
  return /iPad|iPhone|iPod/.test(navigator.userAgent)
}

// 是否在荔枝微课或者梨花 app 中的 webview
export function isInApp() {
  return /(lycheer|lihua)/.test(navigator.userAgent.toLocaleLowerCase())
}

/** 获取app用户数据 */
export const getAppInfo = (action: string)=> {
  return new Promise((resolve, reject) => {
    try {
      (window as any)[`__${action}`] = (data: { [key: string]: any }) => resolve(data)
      // TODO：目前只针对梨花，整体改造的时候，需要针对所有app，最好做成统一的app输出事件
      if (isIOS()) {
        // 可做成提前声明到 LHAPP，或者集成可选链
        if((window as any).webkit.messageHandlers && (window as any).webkit.messageHandlers.LHAPP && (window as any).webkit.messageHandlers.LHAPP.postMessage){
          (window as any).webkit.messageHandlers.LHAPP.postMessage({function: action})
        }
      } else{
        (window as any).LHAPP && (window as any).LHAPP.getUserInfo && (window as any).LHAPP.getUserInfo()
      }
    } catch (error) {
      console.log("getAppInfo:", error)
      reject(error)
    }
  })
}